export const ColorPrimary = {
    lightBlue: '#01C1FF',
    electricBlue: '#1670E4',
    orange: '#FE762A',
};
export const ColorSecondary = {
    lightOrange: '#FF9C41',
    green: '#39D19E',
    redError: '#DE1947',
};
export const ColorGrayscale = {
    black: '#000000',
    grey1: '#6F6F6F',
    grey2: '#B7B7B7',
    grey3: '#E5E5E5',
    lightGrey: '#F6F6F6',
    white: '#FFFFFF',
    skyDark: '#B4B6B8',
    skyLight: '#E3E5E5',
    transparent: 'rgba(255, 255, 255, 0)'
};
const gridBreakpoints = {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1440px'
};
export const breakpointRuleGulliver = `max-width: 320px`;
export const breakpointRuleTablet = `min-width: ${gridBreakpoints.md}`;
export const breakpointRuleDesktop = `min-width: ${gridBreakpoints.lg}`;
export const breakpointRuleOverDesktop = `min-width: ${gridBreakpoints.xxl}`;
export const maxContentWidth = `1200px`;
export const ZIndex = {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
};
